export const buildProfessionalClientSummaryRequest = ({
  clientId,
  salonId,
}) => ({
  url: `/api/users/clients/${clientId}/professional-summary/`,
  params: salonId ? { salon_id: salonId } : undefined,
});
